import React from 'react'
import Layout from '../Layout/Layout'
import PageHeader from '../PageHeader/PageHeader'
import {ClipLoader} from 'react-spinners';

const LoadingScreen = () => {
  return (
    <Layout product='none'>
      <PageHeader title='DreamEx Connect'>
        <div style={{textAlign:'center'}}>
          <ClipLoader
            color='blue'
            loading={true}
          />
        </div>
      </PageHeader>
    </Layout>
  )
}

export default LoadingScreen